import { getCanEditCustomFieldData } from "PFApp/components/custom_values_edit_field/custom_values_edit_field.utils";
import { Inline, Stack } from "PFComponents/containers";
import { TooltipIcon } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { getVisibleProperties } from "PFCore/helpers/templates";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { CustomType, Profile, Subtemplate, Template } from "PFCore/types";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import css from "./attributes_box.module.scss";

type AttributeSubsectionProps = PropsWithChildren<{
  title: string;
  customType: CustomType;
  template: Template;
  subtemplate: Subtemplate | null;
  activityCreator: Profile | null;
}>;

export const AttributeSubsection = ({
  title,
  customType,
  template,
  subtemplate,
  activityCreator,
  children
}: AttributeSubsectionProps) => {
  const { t: tTranslation } = useTranslation();
  const { data: currentProfile } = useCurrentProfile();

  const visibleProperties = getVisibleProperties(subtemplate || template);
  const visiblePropertiesNames = visibleProperties
    .filter(({ type }) => type === "custom_field")
    .map(({ name }) => name);

  const isCustomFieldInForm = visiblePropertiesNames.includes(customType.name);
  const canEditCustomField = getCanEditCustomFieldData({
    adminPage: false,
    customType,
    profile: undefined,
    currentProfile,
    isActivity: true,
    activityCreator,
    t: tTranslation
  });

  if (!isCustomFieldInForm) {
    return null;
  }

  return (
    <Stack className={css.subsection}>
      <Inline>
        <Typography variant="labelRegular" className={css.label}>
          {title}
        </Typography>
        {canEditCustomField.locked && (
          <TooltipIcon
            iconProps={{
              color: "paletteOrange1",
              size: "sm"
            }}
            iconName="warning"
            content={canEditCustomField.lockedTip}
          />
        )}
      </Inline>
      <Inline wrap="wrap">{children}</Inline>
    </Stack>
  );
};
